import { AuditLogInterface } from "../types/AuditLogInterface";

interface FilterOptions {
  period: string;
  customDateFrom?: string;
  customDateTo?: string;
}

const filterAuditLogsByPeriod = (
  auditLogs: AuditLogInterface[],
  options: FilterOptions
): AuditLogInterface[] => {
  if (!auditLogs || auditLogs.length === 0) {
    return [];
  }

  const now = new Date();
  let startDate: Date;
  let endDate: Date = now;

  switch (options.period) {
    case "30days":
      startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      break;
    case "3months":
      startDate = new Date(
        now.getFullYear(),
        now.getMonth() - 3,
        now.getDate()
      );
      break;
    case "6months":
      startDate = new Date(
        now.getFullYear(),
        now.getMonth() - 6,
        now.getDate()
      );
      break;
    case "1year":
      startDate = new Date(
        now.getFullYear() - 1,
        now.getMonth(),
        now.getDate()
      );
      break;
    case "custom":
      if (options.customDateFrom && options.customDateTo) {
        startDate = new Date(options.customDateFrom);
        endDate = new Date(options.customDateTo);
        endDate.setHours(23, 59, 59, 999); // End of day
      } else {
        return auditLogs;
      }

      break;
    default:
      startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  }

  return auditLogs.filter((log) => {
    const logDate = new Date(log.createdAt);

    return logDate >= startDate && logDate <= endDate;
  });
};

export default filterAuditLogsByPeriod;
